import TableCellContent, { TableCellContentProps } from "ds/components/Table/Row/CellContent";
import TableCellGroup from "ds/components/Table/Row/CellGroup";

export type IntentProjectEnvironmentMountedFilesTableCellWrapperProps = {
  isFirst: boolean;
  onPress: () => void;
  isExpanded: boolean;
} & TableCellContentProps;

const IntentProjectEnvironmentMountedFilesTableCell = ({
  children,
  onPress,
  isExpanded,
  isFirst,
  ...props
}: IntentProjectEnvironmentMountedFilesTableCellWrapperProps) => {
  return (
    <TableCellContent {...props}>
      <TableCellGroup
        isActive={!!isFirst}
        onPress={onPress}
        title="View file"
        isGroupOpen={isExpanded}
      >
        {children}
      </TableCellGroup>
    </TableCellContent>
  );
};

export default IntentProjectEnvironmentMountedFilesTableCell;
